/*
  NG Menü – Verhalten für snippets/ng-menu-desktop.liquid (und ng-menu-drawer.liquid).
  Das Markup kommt vollständig vom Server; hier nur Öffnen/Schließen, Tastatur, ARIA und Vorladen der Bilder.
*/
(() => {
  if (window.NgMenu) return;

  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const OPEN_DELAY = 80;
  const CLOSE_DELAY = 150;

  /* ---------- Bilder vorladen ---------- */

  // Menübilder tragen loading="lazy" und liegen in geschlossenen Panels → laden sonst erst beim Öffnen.
  // „eager“ startet den Download mit der passenden srcset-Größe, ohne das Bild anzuzeigen.
  function preload(root) {
    if (!root) return;
    root.querySelectorAll('img.ng-menu-img[loading="lazy"]').forEach((img) => {
      img.loading = 'eager';
    });
  }

  function whenIdle(callback) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(callback, { timeout: 3000 });
    else setTimeout(callback, 1500);
  }

  /* ---------- Desktop ---------- */

  function initDesktop(nav) {
    if (nav.dataset.ngMenuReady) return;
    nav.dataset.ngMenuReady = 'true';

    const items = [...nav.querySelectorAll('[data-ng-menu-details]')];
    const timers = new WeakMap();

    const setOpen = (details, open) => {
      if (details.open === open) return;
      details.open = open;
    };

    const closeAll = (except) => {
      items.forEach((details) => {
        if (details !== except) setOpen(details, false);
      });
    };

    items.forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      const item = details.closest('li') || details;
      const panel = details.querySelector('.ng-menu-desktop__panel');

      // aria-expanded folgt dem tatsächlichen Zustand (Klick, Tastatur, Hover)
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        if (details.open) {
          closeAll(details);
          preload(panel);
        }
      });

      // Hover-Absicht: Bilder sofort laden, kurz verzögert öffnen; beim Verlassen mit Kulanzzeit schließen
      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !DESKTOP.matches) return;
        preload(panel);
        clearTimeout(timers.get(details));
        timers.set(details, setTimeout(() => setOpen(details, true), OPEN_DELAY));
      });
      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(timers.get(details));
        timers.set(details, setTimeout(() => setOpen(details, false), CLOSE_DELAY));
      });

      summary.addEventListener('focus', () => preload(panel));

      // Escape schließt und gibt den Fokus an den Oberpunkt zurück
      details.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !details.open) return;
        event.preventDefault();
        setOpen(details, false);
        summary.focus();
      });

      // Fokus verlässt den Menüpunkt → schließen
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) setOpen(details, false);
      });
    });

    // Klick außerhalb schließt
    document.addEventListener('click', (event) => {
      if (!nav.contains(event.target)) closeAll();
    });

    // Nach dem Laden der Seite im Leerlauf alle Desktop-Menübilder vorladen (beeinflusst LCP nicht)
    const idlePreload = () => whenIdle(() => DESKTOP.matches && preload(nav));
    if (document.readyState === 'complete') idlePreload();
    else window.addEventListener('load', idlePreload, { once: true });
  }

  /* ---------- Mobil-Drawer ---------- */

  // iOS-taugliche Scroll-Sperre: body fixieren und Scrollposition merken
  let lockedScroll = 0;
  function lockScroll() {
    lockedScroll = window.scrollY;
    document.body.classList.add('ng-drawer-open');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScroll}px`;
    document.body.style.width = '100%';
  }
  function unlockScroll() {
    document.body.classList.remove('ng-drawer-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScroll);
  }

  function initDrawer(host) {
    if (host.dataset.ngMenuReady) return;
    host.dataset.ngMenuReady = 'true';

    const toggle = host.querySelector('[data-ng-drawer-open]');
    const dialog = host.querySelector('[data-ng-drawer-dialog]');
    if (!toggle || !dialog || typeof dialog.showModal !== 'function') return;
    const main = dialog.querySelector('[data-ng-drawer-screen="main"]');

    const showScreen = (screen) => {
      dialog.querySelectorAll('[data-ng-drawer-screen]').forEach((node) => {
        node.hidden = node !== screen;
      });
      dialog.querySelector('.ng-drawer__screens').scrollTop = 0;
    };

    const resetScreens = () => {
      showScreen(main);
      dialog.querySelectorAll('[data-ng-drawer-sub]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    };

    // Aktionsbox einer inzwischen beendeten Aktion ausblenden (zwischengespeicherte Seite)
    const syncPromo = () => {
      const promo = dialog.querySelector('[data-ng-drawer-promo]');
      if (!promo || !window.NgDiscount) return;
      const campaign = window.NgDiscount.campaign;
      promo.hidden = !campaign || campaign.code !== promo.dataset.campaignCode;
    };

    const open = () => {
      resetScreens();
      syncPromo();
      preload(main);
      lockScroll();
      dialog.showModal();
      host.dataset.ngDrawerOpen = 'true';
      toggle.setAttribute('aria-expanded', 'true');
      const first = main.querySelector('.ng-drawer__main-item') || main.querySelector('a, button');
      if (first) first.focus();
    };

    // Aufräumen direkt beim Schließen (nicht nur über das asynchrone „close“-Ereignis):
    // Scroll freigeben, aria-expanded zurücksetzen, Hauptscreen zeigen, Fokus zurück auf den Burger.
    const finishClose = () => {
      if (!host.dataset.ngDrawerOpen) return;
      delete host.dataset.ngDrawerOpen;
      unlockScroll();
      toggle.setAttribute('aria-expanded', 'false');
      resetScreens();
      toggle.focus();
    };

    const close = () => {
      if (dialog.open) dialog.close();
      finishClose();
    };

    // Escape löst „cancel“ aus → über close() schließen, damit sofort aufgeräumt wird
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    // Absicht erkannt (Antippen beginnt / Fokus) → Bilder des Hauptscreens schon laden
    ['pointerdown', 'focus'].forEach((type) => toggle.addEventListener(type, () => preload(main), { passive: true }));
    toggle.addEventListener('click', open);

    dialog.querySelector('[data-ng-drawer-close]')?.addEventListener('click', close);

    // Klick auf den abgedunkelten Bereich (außerhalb des Panels) schließt
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    // Absicherung für andere Schließwege (z. B. Formular mit method="dialog")
    dialog.addEventListener('close', finishClose);

    // Untermenüs
    dialog.querySelectorAll('[data-ng-drawer-sub]').forEach((button) => {
      const screen = dialog.querySelector(`#${button.dataset.ngDrawerSub}`);
      if (!screen) return;
      ['pointerdown', 'focus'].forEach((type) => button.addEventListener(type, () => preload(screen), { passive: true }));
      button.addEventListener('click', () => {
        preload(screen);
        showScreen(screen);
        button.setAttribute('aria-expanded', 'true');
        screen.querySelector('[data-ng-drawer-back]')?.focus();
      });
      screen.querySelector('[data-ng-drawer-back]')?.addEventListener('click', () => {
        showScreen(main);
        button.setAttribute('aria-expanded', 'false');
        button.focus();
      });
    });

    // Bildschirm wird breiter als der Drawer-Bereich → Drawer schließen
    const mq = window.matchMedia('(max-width: 989px)');
    mq.addEventListener?.('change', (event) => {
      if (!event.matches && !host.hasAttribute('data-ng-drawer-desktop')) close();
    });
  }

  function init() {
    document.querySelectorAll('[data-ng-menu-desktop]').forEach(initDesktop);
    document.querySelectorAll('[data-ng-drawer]').forEach(initDrawer);
  }

  window.NgMenu = { init, preload };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
